var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-5",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","my-2":""}},[_vm._v("\n    Bienvenido \n  ")]),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":"","my-2":""}},[_vm._v("\n    Utiliza el menu lateral para navegar por la plataforma.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d75e51a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Home.vue
// module id = 7lmb
// module chunks = 11